import { useState, useEffect, useRef } from 'react';
import NET from 'vanta/dist/vanta.net.min';
import { blue } from '@mui/material/colors';

const VantaBg = ({ className, children }) => {
    
    const [vantaEffect, setVantaEffect] = useState(null),
    myRef = useRef(null);

    useEffect(() => {
        if( !vantaEffect ){
            setVantaEffect(
                NET({
                    backgroundColor: '#222',
                    color: blue[ 500 ],
                    el: myRef.current,
                    mouseControls: true,
                    touchControls: true,
                    gyroControls: false,
                    points: 12.00,
                    scale: 1.00,
                    scaleMobile: 1.00,
                    spacing: 20
                })
            )
        }
        return () => {
            if( vantaEffect ) vantaEffect.destroy()
        }
    }, [ vantaEffect, myRef ]);

    return (
        <div ref={ myRef } className={ className }>
            { children }
        </div>
    );
}

export default VantaBg;